'use client';
import { useEffect, useState } from 'react';

type PageInfo = {
  title: string;
};

export function usePageInfo(pathname: string) {
  const [pageInfo, setPageInfo] = useState<PageInfo>({
    title: '',
  });

  useEffect(() => {
    if (typeof window !== 'undefined') {
      const timer = setTimeout(() => {
        setPageInfo({
          title: document.title,
        });
      }, 0);
      return () => clearTimeout(timer);
    }
  }, [pathname]);

  return pageInfo;
}
